module.exports = __webpack_public_path__ + "static/media/26UNRWA11.85cf88ff.jpg";